module.exports = {
  env: 'test',
  domain: ['test.nges.qq.com'],
  mobileDomain: 'testh5.nges.qq.com',
  aegisId: 'jlZIRgHXbxAFIWbChO',
  reportDomain: 'baike.sparta.html5.qq.com',
};
